import React from 'react';
import { toggleClass } from '../../util/dom';
import { BgisButtonIcon } from '../icon';



export const BgisHideHeader = () => {
  return (
    <button className='collapsible bgis-icon bgis-show-header bgis-toggled-overlayable' onClick={() => toggleClass('.bgis', 'hide-header')}>
      <i className="bgis-icon bgis-icon-chevron-down"></i>
    </button>);

};